// http://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Could also use https://github.com/andrewrk/node-diacritics
import removalMap from 'utils/diacritics';
const removeDiacritics = (function() {

	const diacriticsMap = removalMap.reduce((map, replacement) => {
		const base = replacement.base;
		[...replacement.letters].forEach(letter => map[letter] = base);
		return map;
	}, {});

	// eslint-disable-next-line no-control-regex
	return str => str.replace(/[^\u0000-\u007E]/g, a => diacriticsMap[a] || a);
})();

export default removeDiacritics;
